import React, { useEffect, useMemo } from 'react';
import * as PropTypes from 'prop-types';
import cn from 'classnames';

import Icon from '../../../../Icon';
import { STATUS_SURVEY, SURVEY_TYPES } from '../constants';
import styles from '../index.styl';

const SurveyTranslations = {
  [SURVEY_TYPES.PROGRAM]: 'appointment.programForm',
  [SURVEY_TYPES.PRE_VISIT]: 'appointment.preVisitForm',
  [SURVEY_TYPES.PROVIDER_POST_VISIT]: 'appointment.postVisitForm',
};

export function ViewSurvey({
  setAssignmentId,
  formatMessage,
  status,
  name,
  id,
  surveyType,
  isCompletedSurvey,
  isExpired = false,
  targetUserId,
  setIntervieweeId,
}) {
  const statusTitleSurvey = currentStatus => {
    switch (currentStatus) {
      case STATUS_SURVEY.COMPLETED:
        return formatMessage({ id: 'general.completed' });
      case STATUS_SURVEY.EXPIRED:
        return formatMessage({ id: 'chat.placeholders.surveyExpired' });
      case STATUS_SURVEY.UPCOMING:
        return formatMessage({ id: 'appointment.surveys.title.upcoming' });
      default:
        return currentStatus;
    }
  };

  const surveyTypeMessage = useMemo(() => {
    const statusMessage = statusTitleSurvey(status);
    const surveyTypeTranslation = SurveyTranslations[surveyType];
    const message = surveyTypeTranslation
      ? formatMessage({ id: surveyTypeTranslation })
      : '';

    if (message) return `${message}, ${statusMessage}`;

    return statusMessage;
  }, [surveyType, status]);

  useEffect(() => {
    setIntervieweeId(targetUserId);
  }, []);

  return (
    <div className={styles.viewAttachmentWrapper}>
      <div
        className={cn(styles.documentWrapper, {
          [styles.documentWrapperDisabled]: isExpired,
        })}
        onClick={() => !isExpired && !isCompletedSurvey && setAssignmentId(id)}
      >
        <Icon name="up-surveys" size={32} className={styles.icon} />
        <div className={styles.surveyInfoWrapper}>
          <div className={styles.surveyName}>{name}</div>
          <div className={styles.surveyStatus}>{surveyTypeMessage}</div>
        </div>
      </div>
    </div>
  );
}

ViewSurvey.propTypes = {
  formatMessage: PropTypes.func.isRequired,
  status: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  id: PropTypes.number.isRequired,
  isCompletedSurvey: PropTypes.bool,
  isExpired: PropTypes.bool,
  surveyType: PropTypes.string,
  setAssignmentId: PropTypes.func.isRequired,
  targetUserId: PropTypes.number.isRequired,
  setIntervieweeId: PropTypes.func.isRequired,
};



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitSurveyListView/ViewSurvey/index.jsx